import { post } from 'api/BaseApi';
import { TextileVariant } from './fetchTextileVariants';

export const createTextileOrdersTextileVariant = (textileOrderId: number, textileVariantId: number): Promise<TextileVariant> => {
  return post(`/textile_orders_textile_variants`, {
    textile_order_id: textileOrderId,
    textile_variant_id: textileVariantId
  });
};
